export const CHIP_COLUMN_WIDTHS = {
  horizon: { minWidth: 110 },
  status: { minWidth: 160 },
  priority: { minWidth: 120 },
};
